import PropTypes from "prop-types";
import { ThemeProvider } from "@emotion/react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/core/providers/AuthProvider";
import { CaptchaProvider } from "@/core/providers/CaptchaProvider";
import { merge as _merge } from "lodash";

import * as themes from "../themes";
import { NavProvider } from "@/core/providers/NavProvider";
import { SchemaProvider } from "./core/providers/SchemaContext";

// <AppContainer /> - application-level environment
const AppContainer = ({ children, theme }) => {
  const _theme = _merge(themes.defaultTheme, theme);

  return (
    <BrowserRouter>
      <AuthProvider>
        <HelmetProvider>
          <CaptchaProvider>
            <ThemeProvider theme={_theme}>
              <NavProvider>
                <SchemaProvider>
                  <>{children}</>
                </SchemaProvider>
              </NavProvider>
            </ThemeProvider>
          </CaptchaProvider>
        </HelmetProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppContainer;

AppContainer.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};
